import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';

export const useRequestLoginOtp = () => {
  return useMutation({
    mutationFn: async (data: { loginName: string; mfaType: string }) => {
      const response = await HttpService.post('v3/onboarding/user/sendOtp', data);
      return response.data;
    },
    mutationKey: ['requestLoginOtp'],
  });
};
